import { SvgAttribute } from "@/shared/constants/constants";

export const COMPONENT_NAME = "auth-header";

export const SVG: SvgAttribute = {
  logo: `<svg xmlns="http://www.w3.org/2000/svg" width="45" height="40" viewBox="0 0 45 40" fill="none">
    <path d="M17.649 0.099893V9.16161H29.2771L21.7724 16.782L0 0V40H9.05992V18.4231L22.5856 28.8548L35.9543 15.2979V26.4003H45V0.099893H17.649Z" fill="white"/>
  </svg>`,
};
